<template>
    <div class="bg-white">
        <Hero :title="$t('contact.title')" :lead="$t('generic.contact_us')" />

        <div class="relative pt-4 md:pt-10 lg:pt-20 pb-14 xl:pb-28 container text-black">
            <ContactForm
                b2c
                :title="$t('contact.job_seekers.description')"
                subtitle=" "
                :is-on-contact-endpage="true"
            />
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import ContactForm from '@/components/Forms/ContactForm';

export default {
    name: 'Contact',
    components: {
        Hero,
        ContactForm,
    },
    asyncData({ redirect, localePath, $getIsLangKoZhDe }) {
        if ($getIsLangKoZhDe()) {
            return redirect(localePath('/'));
        }
    },
    head() {
        return {
            title: this.$t('contact.title'),
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: this.$getOgTitle(this.$t('contact.title')),
                },
                {
                    hid: 'title',
                    name: 'title',
                    content: this.$getOgTitle(this.$t('contact.title')),
                },
            ],
        };
    },
};
</script>

<style scoped></style>
